import { Trans, useTranslation } from 'react-i18next'

export const Footer = () => {
  const { t } = useTranslation()

  return (
    <footer className="footer">
      <Trans i18nKey="footer.credits">
        Powered by
        <a href={'https://www.liip.ch'} target={'_blank'}>
          Liip
        </a>
        and <a href={'https://www.liipgpt.ch/'} target={'_blank'}></a>
      </Trans>
      &emsp;
      {t('footer.disclaimer')}
    </footer>
  )
}
